import React, { PureComponent } from 'react'
import PanoPlayer from '../../../legacy/panorama/module/PanoPlayer'
import idx from 'idx'
const EventEmitter = require('eventemitter3')
// https://www.npmjs.com/package/eventemitter3

const CursorState = {
    GRAB: 'grab',
    GRABBING: 'grabbing',
}

class PanoPlayerWrapper extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            cursor: CursorState.GRAB,
            alreadyRendered: false,
        }
        this.R = { panoWrapper: undefined }
        this.eventEmitter = new EventEmitter()
    }

    initializePanorama = props => {
        const { handleViewReady, handleOnClick, handleOnMouseUp } = props
        this.panoPlayer = new PanoPlayer(
            Object.assign({}, props.options, { selector: this.R.panoWrapper }, { eventEmitter: this.eventEmitter })
        )
        this.eventEmitter.on('viewReady', this.handleViewReady)
        this.eventEmitter.on('mousedown', this.handleOnClick)
        this.eventEmitter.on('mouseup', this.handleOnMouseUp)
        this.eventEmitter.on('touchstart', this.handleOnClick)
        this.eventEmitter.on('viewReady', () => {
            // console.log('VIEW READY CALLED')
        })
        this.eventEmitter.on('panoLoaded', () => {
            // console.log('PANO LOADED CALLED')
        })
        this.panoPlayer.embed()
    }

    handleProps = props => {
        const { alreadyRendered } = this.state

        if (!alreadyRendered) {
            this.initializePanorama(props)
            this.setState({ alreadyRendered: true })
        }
    }

    resize = ({ width, height }) => this.panoPlayer && this.panoPlayer.setSize(width, height)

    setAutoRotate = ({ auto, speed }) => this.panoPlayer.setAutoRotate(auto, speed)

    handleViewReady = () => {
        this.setAutoRotate({
            auto: true,
            speed: 0.06,
        })
    }

    componentDidMount() {
        this.handleProps(this.props)
    }

    componentWillReceiveProps(newProps) {
        if (!this.props.active && newProps.active) this.initializePanorama(newProps)
        else this.handleProps(newProps)
    }

    componentWillUnmount() {
        this.panoPlayer && this.panoPlayer.destroy()
    }

    handleOnMouseUp = e => {
        this.setState({ cursor: CursorState.GRAB })
    }

    handleOnClick = e => {
        this.setState({ cursor: CursorState.GRABBING })
    }

    render() {
        const { style, isPanoramaBlurred, children, isLandscape, isMobile } = this.props
        const { cursor } = this.state

        const scene = idx(this.panoPlayer, _ => _.panorama.scene)
        const camera = idx(this.panoPlayer, _ => _.panorama.camera.getCamera())
        const renderer = idx(this.panoPlayer, _ => _.panorama.renderer)
        // used for checking shadows
        // if (renderer) {
        //     renderer.shadowMapEnabled = true;
        //     renderer.shadowMapSoft = true;
        // }
        if (camera && isMobile) {
            camera.zoom = isLandscape ? 2 : 1
            camera.updateProjectionMatrix()
        }

        const childrenWithContext = React.Children.map(children, child =>
            React.cloneElement(child, {
                obj: scene,
                scene,
                camera,
                renderer,
                cursor,
            })
        )
        return (
            <div>
                <div
                    ref={c => (this.R.panoWrapper = c)}
                    className="panoWrapper"
                    style={{
                        cursor,
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'inline-block',
                        pointerEvents: 'all',
                        filter: isPanoramaBlurred ? 'blur(2px)' : 'initial',
                        transition: 'filter 1s',
                        ...style,
                    }}
                />
                {childrenWithContext}
            </div>
        )
    }
}
export default PanoPlayerWrapper
